import { Controller } from '@hotwired/stimulus';

// A button that opens a <dialog> by id: showModal() is in every browser we
// serve (Safari 15.4+), where the newer declarative button-to-dialog attributes
// (Safari/iOS before 26.2, Chrome before 135, Firefox before 144) are ignored
// without a sound. The row menu the button sits in (a [popover]) shuts first.
//
//   <button type="button" data-controller="dialog" data-action="dialog#open"
//           data-dialog-id-param="send-42">Reenviar</button>
export default class extends Controller {
  open({ params: { id } }) {
    const dialog = document.getElementById(id);
    if (!dialog) return;

    const menu = this.element.closest('[popover]');
    if (menu?.matches(':popover-open')) menu.hidePopover();
    dialog.showModal();
  }
}
